"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewImage = exports.InlineReactPlayer = exports.DialogReactPlayer = exports.PlayButton = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const lazy_1 = __importDefault(require("react-player/lazy"));
const button_1 = __importDefault(require("../button"));
const Image_1 = __importDefault(require("../media/Image"));
const PREFIX = "YoutubeVideo";
exports.classes = {
    previewImage: `${PREFIX}-previewImage`,
    thumbnail: `${PREFIX}-thumbnail`,
    inPlace: `${PREFIX}-inPlace`,
    playButton: `${PREFIX}-playButton`,
    inline: `${PREFIX}-inline`,
    subtitle: `${PREFIX}-subtitle`,
    svg: `${PREFIX}-svg`,
    overlay: `${PREFIX}-overlay`
};
exports.Root = (0, styles_1.styled)("div")(({ theme, aspectRatio }) => ({
    display: "flex",
    height: "100%",
    minHeight: "80px",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    overflow: "hidden",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    [`.${exports.classes.thumbnail}`]: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        "&:hover": {
            cursor: "pointer"
        },
        "&::after": {
            content: "''",
            background: `${theme.colours.black}a6`,
            position: "absolute",
            zIndex: 1,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    },
    [`&.${exports.classes.inPlace}`]: {
        display: "block",
        "&::after": {
            background: "transparent"
        }
    },
    [`.${exports.classes.playButton}`]: {
        zIndex: 2,
        position: "absolute"
    },
    [`&.${exports.classes.inline}`]: {
        maxWidth: "1070px",
        backgroundColor: theme.colours.black,
        display: "block",
        height: 0,
        margin: "auto",
        position: "relative",
        "&::after": {
            display: "none"
        },
        paddingBottom: aspectRatio && `calc(${aspectRatio} * 100%)`,
        [theme.breakpoints.up(1112)]: {
            paddingBottom: aspectRatio && `calc(${aspectRatio} * 1070px)`
        },
        "& iframe": {
            position: "absolute",
            width: "100%",
            height: "100%"
        },
        [`.${exports.classes.overlay}`]: {
            alignItems: "center",
            backgroundImage: "radial-gradient(circle, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.25) 100%)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            position: "absolute",
            height: "100%",
            width: "100%"
        },
        [`.${exports.classes.playButton}`]: {
            borderRadius: "50%",
            backgroundColor: "rgba(0, 0, 0, 0.35)",
            height: "72px",
            width: "72px",
            zIndex: "initial",
            [`.${exports.classes.svg}`]: {
                fontSize: "48px",
                fill: theme.colours.storm
            },
            "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                [`.${exports.classes.svg}`]: {
                    fill: theme.colours.white
                }
            }
        },
        [`.${exports.classes.subtitle}`]: {
            color: theme.colours.white,
            marginTop: "24px",
            maxWidth: "65%",
            textAlign: "center"
        }
    }
}));
exports.PlayButton = (0, styles_1.styled)(button_1.default)({
    margin: 0,
    padding: 0,
    zIndex: 2
});
exports.DialogReactPlayer = (0, styles_1.styled)(lazy_1.default)(({ theme }) => ({
    [theme.breakpoints.only("xs")]: {
        height: "100% !important"
    },
    [theme.breakpoints.only("xl")]: {
        height: "100% !important"
    }
}));
exports.InlineReactPlayer = (0, styles_1.styled)(lazy_1.default)({
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
});
exports.PreviewImage = (0, styles_1.styled)(Image_1.default)({
    //@ts-expect-error -- It doesn't like the use of `!important`
    position: "absolute !important"
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3lvdXR1YmUtdmlkZW8vc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGlEQUE4QztBQUM5Qyw2REFBNEM7QUFDNUMsdURBQStCO0FBQy9CLDJEQUFtQztBQUVuQyxNQUFNLE1BQU0sR0FBRyxjQUFjLENBQUM7QUFFakIsUUFBQSxPQUFPLEdBQUc7SUFDckIsWUFBWSxFQUFFLEdBQUcsTUFBTSxlQUFlO0lBQ3RDLFNBQVMsRUFBRSxHQUFHLE1BQU0sWUFBWTtJQUNoQyxPQUFPLEVBQUUsR0FBRyxNQUFNLFVBQVU7SUFDNUIsVUFBVSxFQUFFLEdBQUcsTUFBTSxhQUFhO0lBQ2xDLE1BQU0sRUFBRSxHQUFHLE1BQU0sU0FBUztJQUMxQixRQUFRLEVBQUUsR0FBRyxNQUFNLFdBQVc7SUFDOUIsR0FBRyxFQUFFLEdBQUcsTUFBTSxNQUFNO0lBQ3BCLE9BQU8sRUFBRSxHQUFHLE1BQU0sVUFBVTtDQUM3QixDQUFDO0FBTVcsUUFBQSxJQUFJLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQWEsQ0FBQyxFQUFFLEtBQUssRUFBRSxXQUFXLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUN6RSxPQUFPLEVBQUUsTUFBTTtJQUNmLE1BQU0sRUFBRSxNQUFNO0lBQ2QsU0FBUyxFQUFFLE1BQU07SUFDakIsS0FBSyxFQUFFLE1BQU07SUFDYixVQUFVLEVBQUUsUUFBUTtJQUNwQixjQUFjLEVBQUUsUUFBUTtJQUN4QixRQUFRLEVBQUUsVUFBVTtJQUNwQixRQUFRLEVBQUUsUUFBUTtJQUNsQixnQkFBZ0IsRUFBRSxXQUFXO0lBQzdCLGNBQWMsRUFBRSxPQUFPO0lBQ3ZCLGtCQUFrQixFQUFFLGVBQWU7SUFDbkMsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxTQUFTLEVBQUUsQ0FBQyxFQUFFO1FBQ3pCLE9BQU8sRUFBRSxNQUFNO1FBQ2YsVUFBVSxFQUFFLFFBQVE7UUFDcEIsY0FBYyxFQUFFLFFBQVE7UUFDeEIsTUFBTSxFQUFFLE1BQU07UUFDZCxLQUFLLEVBQUUsTUFBTTtRQUNiLFNBQVMsRUFBRTtZQUNULE1BQU0sRUFBRSxTQUFTO1NBQ2xCO1FBQ0QsVUFBVSxFQUFFO1lBQ1YsT0FBTyxFQUFFLElBQUk7WUFDYixVQUFVLEVBQUUsR0FBRyxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUssSUFBSTtZQUN0QyxRQUFRLEVBQUUsVUFBVTtZQUNwQixNQUFNLEVBQUUsQ0FBQztZQUNULEdBQUcsRUFBRSxDQUFDO1lBQ04sS0FBSyxFQUFFLENBQUM7WUFDUixNQUFNLEVBQUUsQ0FBQztZQUNULElBQUksRUFBRSxDQUFDO1NBQ1I7S0FDRjtJQUNELENBQUMsS0FBSyxlQUFPLENBQUMsT0FBTyxFQUFFLENBQUMsRUFBRTtRQUN4QixPQUFPLEVBQUUsT0FBTztRQUNoQixVQUFVLEVBQUU7WUFDVixVQUFVLEVBQUUsYUFBYTtTQUMxQjtLQUNGO0lBQ0QsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxVQUFVLEVBQUUsQ0FBQyxFQUFFO1FBQzFCLE1BQU0sRUFBRSxDQUFDO1FBQ1QsUUFBUSxFQUFFLFVBQVU7S0FDckI7SUFDRCxDQUFDLEtBQUssZUFBTyxDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQUU7UUFDdkIsUUFBUSxFQUFFLFFBQVE7UUFDbEIsZUFBZSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztRQUNwQyxPQUFPLEVBQUUsT0FBTztRQUNoQixNQUFNLEVBQUUsQ0FBQztRQUNULE1BQU0sRUFBRSxNQUFNO1FBQ2QsUUFBUSxFQUFFLFVBQVU7UUFDcEIsVUFBVSxFQUFFO1lBQ1YsT0FBTyxFQUFFLE1BQU07U0FDaEI7UUFDRCxhQUFhLEVBQUUsV0FBVyxJQUFJLFFBQVEsV0FBVyxVQUFVO1FBQzNELENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtZQUM1QixhQUFhLEVBQUUsV0FBVyxJQUFJLFFBQVEsV0FBVyxZQUFZO1NBQzlEO1FBQ0QsVUFBVSxFQUFFO1lBQ1YsUUFBUSxFQUFFLFVBQVU7WUFDcEIsS0FBSyxFQUFFLE1BQU07WUFDYixNQUFNLEVBQUUsTUFBTTtTQUNmO1FBQ0QsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxPQUFPLEVBQUUsQ0FBQyxFQUFFO1lBQ3ZCLFVBQVUsRUFBRSxRQUFRO1lBQ3BCLGVBQWUsRUFDYiwwRUFBMEU7WUFDNUUsT0FBTyxFQUFFLE1BQU07WUFDZixhQUFhLEVBQUUsUUFBUTtZQUN2QixjQUFjLEVBQUUsUUFBUTtZQUN4QixRQUFRLEVBQUUsVUFBVTtZQUNwQixNQUFNLEVBQUUsTUFBTTtZQUNkLEtBQUssRUFBRSxNQUFNO1NBQ2Q7UUFDRCxDQUFDLElBQUksZUFBTyxDQUFDLFVBQVUsRUFBRSxDQUFDLEVBQUU7WUFDMUIsWUFBWSxFQUFFLEtBQUs7WUFDbkIsZUFBZSxFQUFFLHFCQUFxQjtZQUN0QyxNQUFNLEVBQUUsTUFBTTtZQUNkLEtBQUssRUFBRSxNQUFNO1lBQ2IsTUFBTSxFQUFFLFNBQVM7WUFDakIsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxHQUFHLEVBQUUsQ0FBQyxFQUFFO2dCQUNuQixRQUFRLEVBQUUsTUFBTTtnQkFDaEIsSUFBSSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSzthQUMxQjtZQUNELFNBQVMsRUFBRTtnQkFDVCxlQUFlLEVBQUUsb0JBQW9CO2dCQUNyQyxDQUFDLElBQUksZUFBTyxDQUFDLEdBQUcsRUFBRSxDQUFDLEVBQUU7b0JBQ25CLElBQUksRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7aUJBQzFCO2FBQ0Y7U0FDRjtRQUNELENBQUMsSUFBSSxlQUFPLENBQUMsUUFBUSxFQUFFLENBQUMsRUFBRTtZQUN4QixLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO1lBQzFCLFNBQVMsRUFBRSxNQUFNO1lBQ2pCLFFBQVEsRUFBRSxLQUFLO1lBQ2YsU0FBUyxFQUFFLFFBQVE7U0FDcEI7S0FDRjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxVQUFVLEdBQUcsSUFBQSxlQUFNLEVBQUMsZ0JBQU0sQ0FBQyxDQUFDO0lBQ3ZDLE1BQU0sRUFBRSxDQUFDO0lBQ1QsT0FBTyxFQUFFLENBQUM7SUFDVixNQUFNLEVBQUUsQ0FBQztDQUNWLENBQUMsQ0FBQztBQUVVLFFBQUEsaUJBQWlCLEdBQUcsSUFBQSxlQUFNLEVBQUMsY0FBVyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ25FLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtRQUM5QixNQUFNLEVBQUUsaUJBQWlCO0tBQzFCO0lBQ0QsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFO1FBQzlCLE1BQU0sRUFBRSxpQkFBaUI7S0FDMUI7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVTLFFBQUEsaUJBQWlCLEdBQUcsSUFBQSxlQUFNLEVBQUMsY0FBVyxDQUFDLENBQUM7SUFDbkQsUUFBUSxFQUFFLFVBQVU7SUFDcEIsR0FBRyxFQUFFLEtBQUs7SUFDVixJQUFJLEVBQUUsS0FBSztJQUNYLFNBQVMsRUFBRSx1QkFBdUI7Q0FDbkMsQ0FBQyxDQUFDO0FBRVUsUUFBQSxZQUFZLEdBQUcsSUFBQSxlQUFNLEVBQUMsZUFBSyxDQUFDLENBQUM7SUFDeEMsNkRBQTZEO0lBQzdELFFBQVEsRUFBRSxxQkFBcUI7Q0FDaEMsQ0FBQyxDQUFDIn0=